<template>
	<div class="main">
        <div class="main-title">
            <span class="main-back" @click="goBack"></span>
            <span>填写图集信息</span>
        </div>
		<div class="main-container">
			<div class="group-atlas">
				<h3>图集标题</h3>
				<input type="text" class="group-input" placeholder="请输入标题(5-30字)" v-model="articleTitle"/>
			</div>
			<div class="group-atlas">
				<h3 class="key-words-title">关键词</h3>
				<input type="text" class="group-input key-words" placeholder="请输入关键字" v-model="keyWordTag" @keyup.enter="addTag"/>
				<a class="add-btn" href="javascript:;" @click="addTag">添加</a>
				<ul class="key-words-container">
					<li v-for="(tag, index) in keyWordArr" :key="index"><span class="tag">{{tag}}</span><span class="del" @click="tagDelete(index)">×</span></li>
					<li v-if="tagAddShow" class="placeholder"></li>
				</ul>
			</div>
			<div class="group-atlas">
				<h3>图片<span class="edit" @click="editImgList">编辑</span></h3>
				<div class="imgs-container">
					<ul class="group-imgs" ref="imgList" :style="'width:' + width">
						<li v-for="img in imgList" :key="img.url"><img :src="img.url"></li>
						<!-- <li>
		                    <el-upload
							  	class="add-groupImgs"
							  	:action="eatlasUploadUrl"
                				:before-upload="handleBefore"
							  	:on-success="handleSuccess"
							  	:on-error="handleError"
							  	multiple
							  	:show-file-list='false'
							  	:file-list="fileList">
							  	<label><span class="upload-icon"></span></label>
							</el-upload>
		                </li> -->
					</ul>
				</div>
			</div>
			<div class="group-atlas">
				<h3>分类</h3>
				<select class="classification" v-model="className">
					<option value="">请选择</option>
	                <option value="博览">博览</option>
	                <option value="搞笑">搞笑</option>
	                <option value="美女">美女</option>
	                <option value="军事">军事</option>
	                <option value="娱乐">娱乐</option>
	                <option value="体育">体育</option>
	                <option value="历史">历史</option>
	                <option value="汽车">汽车</option>
	                <option value="自然">自然</option>
	                <option value="时尚">时尚</option>
	                <option value="科技">科技</option>
	                <option value="游戏">游戏</option>
	                <option value="家居">家居</option>
	                <option value="旅游">旅游</option>
				</select>
			</div>
			<div class="group-atlas imgsCover">
				<h3 class="cover">
					<span :class="autoCover ? 'active' : ''" @click="coverStatusYes">自动封面</span>
					<span :class="!autoCover ? 'active' : ''" @click="coverStatusNo">手动封面</span>
				</h3>
				<div v-if="!autoCover" class="cover-container">
                    <div class="add_pictures">
	                    <el-upload
						  	class="add-cover cover1"
						  	:action="eatlasUploadUrl"
                			:before-upload="handleBefore"
						  	:on-success="coverSuccess1"
						  	:on-error="coverError1"
						  	:show-file-list='false'>
						  	<img v-if="coverImgList.coverImg1" :src="coverImgList.coverImg1" class="avatar">
						  	<label v-else ><span class="upload-icon"></span></label>
						</el-upload>
                        <div v-if="coverImgList.coverImg1" class="delete-img" @click="deleteCover(1)">×</div>
                    </div>
                    <div class="add_pictures">
	                    <el-upload
						  	class="add-cover cover2"
						  	:action="eatlasUploadUrl"
                			:before-upload="handleBefore"
						  	:on-success="coverSuccess2"
						  	:on-error="coverError2"
						  	:show-file-list='false'>
						  	<img v-if="coverImgList.coverImg2" :src="coverImgList.coverImg2" class="avatar">
						  	<label v-else ><span class="upload-icon"></span></label>
						</el-upload>
                        <div v-if="coverImgList.coverImg2" class="delete-img" @click="deleteCover(2)">×</div>
                    </div>
                    <div class="add_pictures">
	                    <el-upload
						  	class="add-cover cover3"
						  	:action="eatlasUploadUrl"
                			:before-upload="handleBefore"
						  	:on-success="coverSuccess3"
						  	:on-error="coverError3"
						  	:show-file-list='false'>
						  	<img v-if="coverImgList.coverImg3" :src="coverImgList.coverImg3" class="avatar">
						  	<label v-else ><span class="upload-icon"></span></label>
						</el-upload>
                        <div v-if="coverImgList.coverImg3" class="delete-img" @click="deleteCover(3)">×</div>
                    </div>
				</div>
			</div>
			<div class="group-atlas isoriginal" v-if="isoriginalShow">
				<el-radio class="isoriginalRadio" v-model="isoriginal" label="1">原创</el-radio>
  				<el-radio class="isoriginalRadio" v-model="isoriginal" label="0">非原创</el-radio>
  				<!-- <a href="javascript:;" class="original-statement" @click="originalMask">《原创声明》</a> -->
			</div>
			<div class="group-btn">
				<!-- <a class="saveDraft" href="javascript:;">存草稿</a> -->
				<a :class="releaseBtnDisabled ? 'release' : 'release disabled'" href="javascript:;" @click="atlasUpload">发布</a>
			</div>
		</div>
    </div>
</template>
<script>
	import {getuserinfo, atlasUpload} from './../axios/api.js'

	export default {
		name: 'RegistType',
		data (){
			return {
				width: '',
				articleTitle: '',
				className: '',
				autoCover: true,
				tagAddShow: true,
				keyWordTag: '',
				keyWordArr: [],
				fileList: [],
				coverImgList: {
					coverImg1: "",
					coverImg2: "",
					coverImg3: ""
				},
				imgList: [],
				eatlasUploadUrl: '',
				isoriginal: '',
				contentid: 0,
				isoriginalShow: false,
				releaseBtnDisabled: true,
				formData: {},
			}
		},
        mounted(){
        	this.getRouteData();
        	this.eatlasUploadUrl = "http://"+window.location.host+'/picUpload';
        	// this.setImgContainerWidth();
            if(this.$route.query.imgList && typeof(this.$route.query.imgList[0])=='object' && this.$route.query.imgList[0].url){
                this.imgList = this.$route.query.imgList;
                this.setImgContainerWidth();
                // console.log(this.imgList);
            }
            if(this.$route.query.formData){
                this.formData = this.$route.query.formData;
            }
            if(this.formData.title){
        		this.articleTitle = this.formData.title;
            }
            if(this.formData.keywordsStr){
        		this.keyWordArr = this.formData.keywordsStr;
            }
            if(this.formData.mainType){
	        	this.className = this.formData.mainType;
            }
            if(this.formData.covers){
	        	this.coverImgList = this.formData.covers;
            }
            if(this.formData.isoriginal == 0 || this.formData.isoriginal == 1){
	        	this.isoriginal = this.formData.isoriginal;
            }
        },
        components: {

        },
		methods:{
			getRouteData (){
				// 获取用户信息
				// if(this.$route.query.user.mediaHeadPic){
				// 	this.userInfo = this.$route.query.user;
				// }
				let that = this;
                getuserinfo().then(result => {
                    if (result.user) {
						if(result.user.originallevel != 0){
							that.isoriginalShow = true;
						}else{
							that.isoriginalShow = false;
						}
                    }
                })
            },
			GetStringByteLength (val) {
		        var Zhlength = 0; // 全角
		        var Enlength = 0; // 半角
		        for (var i = 0; i < val.length; i++) {
		            if (val.substring(i, i + 1).match(/[^\x00-\xff]/ig) != null)
		                Zhlength += 1;
		            else
		                Enlength += 1;
		        }
		        // 返回当前字符串字节长度
		        return (Zhlength * 2) + Enlength;
		    },
			editImgList (){
	      		let params = {
                    title: this.articleTitle,
                    keywordsStr: this.keyWordArr,
                    mainType: this.className,
                    autocover: 1,
                    covers: this.coverImgList,
                    isoriginal: this.isoriginal
	      		}

				this.$router.push({path: '/EditImgList', query:{imgList: this.imgList, formData: params}});
			},
			coverStatusYes (){
				this.autoCover = true;
			},
			goBack (){
				this.$router.push({path: '/Homepage'});
			},
			coverStatusNo (){
				this.autoCover = false;
			},
			setImgContainerWidth (){
	        	let length = this.imgList.length;
	        	let width = 1.45 * (length+1) + 0.5;
	        	let imgListContainerWidth = width + 'rem';
	        	this.width = imgListContainerWidth;
			},
			tagDelete (index){
				// console.log(this.keyWordArr);
				this.keyWordArr.splice(index, 1);

				if(this.keyWordArr.length < 6){
					this.tagAddShow = true;
				}
				// console.log(this.keyWordArr);
			},
			addTag (){
				let tagName = this.keyWordTag.trim();
				if(!tagName){
					return;
				}
				if(this.GetStringByteLength(tagName) > 10){
					this.$layer.toast({
					  	className: 'keyWord', // 图标clssName 如果为空 toast位置位于下方,否则居中 
					  	content: '请输入五个以内汉字或十个字母以内单词',
					  	time: 2000 // 自动消失时间 toast类型默认消失时间为2000毫秒 
					})
					return;	
				}
				if(this.keyWordArr.length >= 6){
					this.$layer.toast({
					  	className: 'keyWord', // 图标clssName 如果为空 toast位置位于下方,否则居中 
					  	content: '关键词数量不能大于6个',
					  	time: 2000 // 自动消失时间 toast类型默认消失时间为2000毫秒 
					})
					this.keyWordTag = '';
					return;	
				}
				this.keyWordArr.push(tagName);
				if(this.keyWordArr.length >= 6){
					this.tagAddShow = false;
				}
				this.keyWordTag = '';
			},
            handleBefore (file) {
                console.log(file);
            },
      		handleSuccess (response, file, fileList) {
      			let fileData = {
      				name: file.name,
                    desc: '',
      				url: response.urls[0].src
      			}
      			this.imgList.push(fileData);
      			this.setImgContainerWidth();
	      	},
      		handleError (err, file, fileList) {
		        this.$layer.dialog({
                    content: '上传失败，请重新尝试',
                    time: 2000
                })
	      	},
      		coverSuccess1 (response, file, fileList) {
      			this.coverImgList.coverImg1 = response.urls[0].src;
	      	},
      		coverError1 (err, file, fileList) {
      			// console.log(arguments)
		        this.$layer.dialog({
                    content: '上传失败，请重新尝试',
                    time: 2000
                })
	      	},
      		coverSuccess2 (response, file, fileList) {
      			this.coverImgList.coverImg2 = response.urls[0].src;      			
	      	},
      		coverError2 (err, file, fileList) {
      			// console.log(arguments)
		        this.$layer.dialog({
                    content: '上传失败，请重新尝试',
                    time: 2000
                })
	      	},
      		coverSuccess3 (response, file, fileList) {
      			this.coverImgList.coverImg3 = response.urls[0].src;
	      	},
      		coverError3 (err, file, fileList) {
      			// console.log(arguments)
		        this.$layer.dialog({
                    content: '上传失败，请重新尝试',
                    time: 2000
                })
	      	},
	      	coverClick (e){
	      		$(e.target).closest('.add_pictures').find('input').click();
	      	},
	      	deleteCover (index){
	      		this.coverImgList['coverImg'+index] = '';
	      	},
	      	atlasUpload (){
	      		if(this.releaseBtnDisabled){
		      		let coverArr = [];
		      		coverArr.push(this.coverImgList.coverImg1);
		      		coverArr.push(this.coverImgList.coverImg2);
		      		coverArr.push(this.coverImgList.coverImg3);

		      		let imgDescArr = [];
		      		let imgSrcArr = [];
		      		for(let i = 0; i < this.imgList.length; i++){
						imgDescArr.push(this.imgList[i].desc)
						imgSrcArr.push(this.imgList[i].url)
		      		}
		      		
		      		let params = {
	                    mainType: this.className,
	                    title: this.articleTitle,
	                    source: '东方号',
	                    url: 'dsfsfdsfdsfs',
	                    contentid: this.contentid,
	                    keywordsStr: this.keyWordArr.join(','),
	                    imgs: imgSrcArr.join(','),
	                    covers: coverArr.join(','),
	                    autocover: 1,
	                    imgsDesc: imgDescArr.join(','),
	                    isoriginal: this.isoriginal
		      		}
		      		if(params.title.length < 5){
		      			this.$layer.dialog({
		                    content: '标题至少五个字',
		                    time: 2000
		                })
		                return;
		      		}else if(params.title.length > 30){
		      			this.$layer.dialog({
		                    content: '标题最多30字',
		                    time: 2000
		                })
		                return;
		      		}
		      		if(this.keyWordArr.length < 1){
		      			this.$layer.dialog({
		                    content: '请输入关键字',
		                    time: 2000
		                })
		                return;
		      		}
		      		if(imgSrcArr.length < 5){
		      			this.$layer.dialog({
		                    content: '请至少添加五张图片',
		                    time: 2000
		                })
		                return;
		      		}
		      		if(!params.mainType){
		      			this.$layer.dialog({
		                    content: '请选择分类',
		                    time: 2000
		                })
		                return;
		      		}
		      		if(params.autocover != 1 && coverArr.length < 3){
		      			this.$layer.dialog({
		                    content: '请添加封面',
		                    time: 2000
		                })
		                return;
		      		}
		      		if(this.isoriginalShow && params.isoriginal == ''){
		      			this.$layer.dialog({
		                    content: '请选择原创',
		                    time: 2000
		                })
		                return;
		      		}
		      		this.releaseBtnDisabled = false;
		      		let that = this;
		      		this.$layer.dialog({
						  title: '提示', // 第一个是标题内容  第二个是标题栏的style(可以为空) 
						  content: '确认发布吗？',
						  btn: ['取消','确定']
					}).then((res) => {
			          	if(res == 0){
			          		return;
			          	}else{
			      			this.$layer.dialog({
			                    content: '发布中',
			                    time: 2000
			                })
				      		atlasUpload(params).then( result => {
				      			if (result && result.stat == 1) {
							        this.$layer.dialog({
										  title: '提示', // 第一个是标题内容  第二个是标题栏的style(可以为空) 
										  content: '发布成功',
										  btn: ['确定']
									}).then(() => {
					      				that.releaseBtnDisabled = true;
							          	that.$router.push({path: '/Pagearticlelist'});
							        })
			                    } else if (result && result.stat == 3) {
							        this.$layer.dialog({
										  title: '发布失败', // 第一个是标题内容  第二个是标题栏的style(可以为空) 
										  content: result.msg,
										  btn: ['确定']
									})
			                    } else {
							        this.$layer.dialog({
										  title: '发布失败', // 第一个是标题内容  第二个是标题栏的style(可以为空) 
										  content: result.msg,
										  btn: ['确定']
									})
			                    }
				      		})
			          	}
			        })
	      		}
	      	},
	      	originalMask (){

	      	}
		}
	}
</script>
<style scoped>
    input::-webkit-input-placeholder {
		color: #bbb;
	}
	.main-title {
	    position: relative;
	    background: #fff;
	    line-height: 0.9rem;
	    font-size: 0.34rem;
	    color: #333333;
	    text-align: center;
	    border-bottom: 1px solid #eee;
	}
	.main-back{
	    float: left;
	    display: inline-block;
	    width: 0.5rem;
	    height: 0.5rem;
	    background: url('./../assets/img/back-btn.png') no-repeat center center;
	    background-size: 0.45rem 0.45rem;
	    position: absolute;
	    top:  0.2rem;
	    left: 0.1rem;
	}
	.main-container{
		background: #eee;
	}
	.group-atlas{
		background: #fff;
		margin-bottom: 0.2rem;
		padding: 0 0.05rem;
	}
	.group-atlas h3{
		font-size: 0.32rem;
		height: 0.9rem;
		font-weight: normal;
		line-height: 1rem;
		border-bottom: 1px solid #e1e1e1;
		text-indent: 0.25rem;
	}
	.group-atlas .key-words-title{
		border-bottom: 0;
	}
	.group-atlas .group-input{
		width: 100%;
		padding: 0.25rem;
		font-size: 0.36rem;
	}
	.group-atlas .key-words{
		width: 75%;
		border: 1px solid #aaa;
		padding: 0.15rem;
		margin: 0.1rem; 
		margin-top: 0;
	}
	.group-atlas .add-btn{
		background: #fc4a44;
		color: #fff;
		font-size: 0.32rem;
		display: inline-block;
		height: 0.7rem;
		width: 1.35rem;
		line-height: 0.7rem;
		text-align: center;
		position: relative;
		top: -0.015rem;
		border-radius: 0.1rem;
	}
	.key-words-container {
		font-size: 0.26rem;
		overflow: hidden;
		padding: 0.1rem;
		padding-top: 0.05rem;
	}
	.key-words-container .placeholder{
		width: 1.1rem;
		height: 0.6rem;
		/*border: 1px solid #ddd;*/
	}
	.key-words-container > li{
		background: rgba(255, 120, 120, 0.6);
		float: left;
		overflow: hidden;
		margin-right: 0.15rem;
		margin-bottom: 0.1rem;
		/*border: 1px solid #ddd;*/
		color: #666;
		border-radius: 0.1rem;
	}
	.key-words-container > li .tag{
		float: left;
		display: inline-block;
		height: 0.6rem;
		line-height: 0.6rem;
		padding: 0 0.1rem;
	}
	.key-words-container > li .del{
		float: left;
		display: inline-block;
		padding: 0.05rem;
		width: 0.46rem;
		height: 0.6rem;
		text-align: center;
		color: #fc4a44;
		font-size: 0.48rem;
		line-height: 0.48rem;
		/*border: 1px solid #ddd;*/
		/*border-left: 0;*/
	}
	.imgs-container{
		width: 100%;
		height: 1.6rem;
		overflow-y: hidden;
		overflow-x: auto;
	}
	.imgs-container::-webkit-scrollbar {
	    height: 0.12rem;
	    background-color: transparent;
	}
	.imgs-container::-webkit-scrollbar-thumb {
	    background-color: transparent;
	    border-radius: 0.05rem;
	}
	.imgs-container::-webkit-scrollbar-track {
	    -webkit-box-shadow: inset 0 0 0.05rem transparent;
	    background-color: transparent;
	    border-radius: 0.05rem;
	}
	.group-atlas .group-imgs {
		min-width: 100%;
		padding: 0.25rem;
		overflow: hidden;
	}
	.group-atlas .group-imgs li {
		float: left;
		width: 1.35rem;
		height: 1.1rem;
		margin-right: 0.1rem;
	}
	.group-atlas .group-imgs img{
		width: 100%;
		height: 100%;
	}
	.add-groupImgs{
		width: 100%;
		height: 100%;
		position: relative;
	}
	.add-groupImgs .upload-icon{
		display: inline-block;
		width: 1.35rem;
		height: 1.1rem;
		/*position: absolute;
		top: 0;
		left: 0;
		z-index: 2;*/
	    background: url('./../assets/img/addimg.png') no-repeat center center;
	    background-size: cover;
	}
	.group-atlas h3 .edit{
		float: right;
		margin-right: 0.25rem;
	}
	.group-atlas .classification{
		width: 85%;
		border: 0;
		font-size: 0.36rem;
		text-indent: 0.25rem;
		padding: 0.15rem 0;
		height: 1rem;
		color: #bbb;
	}
	.group-atlas .classification option{
		width: 80%;
		margin: 0 auto;
	}
	.group-atlas .cover span{
		margin-right: 0.25rem;
		padding: 0 0.2rem;
		padding-bottom: 0.2rem;
	}
	.group-atlas .cover span.active{
		border-bottom: 2px solid #fc4a44;
	}
	.group-atlas .cover-container {
		overflow: hidden;
		padding: 0.3rem 0.25rem;
	}
	.group-atlas .cover-container .add_pictures {
	    width: 2rem;
	    height: 1.4rem;
	    line-height: 1.4rem;
	    text-align: center;
	    font-size: 0.4rem;
	    float: left;
	    background: #f0f1f3;
	    color: #999999;
	    margin-right: 0.25rem;
	    cursor: pointer;
	    position: relative;
	}
	.group-atlas .cover-container .btn-image {
	    width: 100%;
	    height: 100%;
	    display: block;
	    position: absolute;
	    top: 0;
	    left: 0;
	    cursor: pointer;
	    z-index: 2;
	}
	.group-atlas .cover-container .add_pictures img {
	    width: 100%;
	    height: 100%;
	    display: block;
	    position: absolute;
	    top: 0;
	    left: 0;
	}
	.group-atlas .cover-container .add_pictures .delete-img {
	    width: 0.35rem;
	    height: 0.35rem;
	    position: absolute;
	    top: -0.17rem;
	    right: -0.17rem;
	    z-index: 2;
	    text-align: center;
	    line-height: 0.35rem;
	    font-size: 0.38rem;
	    /*display: none;*/
	    background: rgba(0, 0, 0, 0.8);
	    border-radius: 50%;
	    color: #fff;
	}
	.imgsCover{
		padding-bottom: 0.2rem;
	}
	.group-btn{
		background: #fff;
		padding: 0 0.05rem;
		padding-top: 0.2rem;
		width: 100%;
		text-align: center;
		padding-bottom: 0.5rem;
	}
	.group-btn a{
		font-size: 0.32rem;
		display: inline-block;
		height: 0.7rem;
		width: 1.5rem;
		text-align: center;
		line-height: 0.7rem;
		border: 1px solid #ddd;
		margin-right: 0.2rem;
		border-radius: 0.05rem;
	}
	.group-btn a.release{
		border-color: #fc4a44;
		background: #fc4a44;
		color: #fff;
	}
	.group-btn a.release.disabled{
		border-color: #999;
		background: #999;
	}
	.add-cover .upload-icon{
		display: inline-block;    
		width: 2rem;
	    height: 1.4rem;
	    background: url('./../assets/img/addimg.png') no-repeat center center;
	    background-size: cover;
	}
	.add-cover .avatar {
	    width: 100%;
	    height: 100%;
	    display: block;
  	}
  	.isoriginal{
  		padding-left: 0.45rem;
  		padding-bottom: 0.2rem;
  	}
  	.original-statement {
	    color: #0099FF;
	    font-size: 0.28rem;
	    margin-left: 1.5rem;
	}
</style>


// WEBPACK FOOTER //
// src/pages/pageatlas.vue